var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"title":"invoices.income.label","bread-crumb-data":_vm.breadCrumbData}},[_c('invoices-table',{attrs:{"type":'INCOME',"page-data-id":"invoicesIncome"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }